export default "__VITE_ASSET__6HRUBNWQ__"